/*
 * @Descripttion:
 * @Author: yhy
 * @LastEditTime: 2021-06-21 15:04:35
 */
import { InterfaceConfig, ServerConfig } from "../common/network/httpMgr";
import envConfig from "../common/env/envConfig";
import { getCurEnvData } from "../common/env/env";

export const serverConfig: ServerConfig = {
  serverDomain: "",
};

export const SERVER_DATA_FROM = "mobile";

// api枚举
export enum ApiEnums { // 记录的是action
  GET_CATEGORY_LIST = "mall.category.list", // 获取类目列表
  GET_SKU_LIST = "mall.goods.list", // 获取优惠券列表接口
  GET_SKU_COMBINE_LIST = "mall.zone.good.list", // 获取商品列表（含超值推荐）
  GET_GREAT_VALUE_LIST = "mall.great.value", // 获取超值推荐模块数据
  GET_SKU_DETAIL = "mall.goods.detail", // 优惠券详情列表
  BUY_GOODS = "mall.goods.purchase", // 购买商品
  BUY_COMBI_GOODS = "couponmall.tyingmall.goods.purchase", // 购买搭售商品
  GET_BUY_LIST = "couponmall.user.order.records", // 购买记录
  GET_BUY_DETAIL = "couponmall.user.order.detail", // 购买订单详情
  GET_CITY_LIST = "mall.city.list", // 城市列表

  GET_PAY_INFO = "com.alphapay.paymentOrder.pay", // 微信, ali支付

  GET_GROUPON_LIST = "activity.groupbuy.recommendActivities", // 获取拼团列表

  GET_OPENID = "user.account.getOpenId",
  GET_WEIXINSIGN = "user.account.getSign",
  // GET_VALIDATEOPENID = 'user.account.validateWxUser'

  SKU_TIMELIMIT_LIST = "sku.timelimit.list", // 限时抢购商品列表

  NEW_SKU_TIMELIMIT_LIST = "sku.limited.time.buy.list",

  TIMELIMIT_ORDER_QUERY = "timelimit.order.query", // 限时购商品订单查询

  PURCHASE_GOODS = "mall.goods.activity.purchase", // 限时抢购下单
  GET_LAUNCH_LIST = "mall.goods.launch",
  GET_JUMP_LINK = "hellomall.config.category", // 获取订单跳转链接

  GET_RECOMMENDLIST = "hellomall.goods.homePageList", // 获取商品列表

  GET_COUPONGOODS = "rent.user.mall.queryCouponGoodsProductDetailList", // 电动车卡券

  LIMIT_SWITCH = "homepagge.new.switch",

  CHECK_REMINDER = "/reminder/check", // 校验提醒状态

  ADD_REMINDER = "/reminder/add", // 添加提醒状态

  CUSTOM_REFUND = "user.order.custom.refund", // 用户订单退款

  OUT_USE_URL = "coupon.use.config.out", // 获取去使用跳转外部链接

  SUPPER_USER_DISCOUNT = "mall.super.user.discount",

  FETCH_RECM_SKU = "mall.goods.app.recommend",

  /** 券去使用配置 */
  FETCH_COUPON_GOUSE_CONFIG = "couponmall.coupon.gouse",

  /** 获取搭售商品 */
  FETCH_COMBI_PRODUCT = "couponmall.tyingmall.goods.info",

  /** 获取随心配商品 */
  FETCH_FREE_COMPOSE_PRODUCTS = "couponmall.freecmn.goods.list",

  /** 多商品下单 */
  BUY_MULTI_GOODS = "couponmall.order.create",

  /** 获取两轮骑行卡列表 */
  FETCH_BIKE_CARD_LIST = "tw.ridecard.commodity",

  /** 两轮骑行卡预下单 */
  BUY_BIKE_CARD = "tw.standard.preOrder",

  /** 查询用户签约状态 */
  PAY_AFTER_USE_STATUS = "user.account.getAgreementRecordByChannel",

  /** 订单授权结果查询 */
  PAY_AFTER_USE_FROZEN = "mall.order.credit.get",

  /** 用户维度业务场景校验 */
  BIZ_SCENE_CHECK = "tw.card.biz.scene.check",

  APPID_PRE_CHECK = "couponmall.order.pre.check",

  /** 获取心智建设疲劳度 */
  MENTAL_CHECK_USER_VISIT = "mall.user.visit",

  /** 秒杀 */
  SECKILL_KILL = "mall.goods.kill",

  /** 查询秒杀订单结果 */
  SECKILL_KILL_ORDER = "kill.order.query",

  /** 获取用户签约记录 */
  GET_USER_SIGN_RECORD = "coupon.user.sign.record",
  /** 随心配商品组合列表 */
  FETCH_FREE_COMPOSE_PRODUCTS_LIST = "couponmall.freecmn.goods.listNew",
  /** 司南的接口来判断是否展示 */
  NPS_IS_SHOW = "user.compass.getSurveyDetailNew",
  /** 两轮领取一亿壕补优惠券 */
  TWO_WHEEL_GET_ONE_BILLION_DISCOUNT_COUPON = "tw.ridecard.discounts",

  /** 卡券用户优惠信息查询 @ref https://yapi.hellobike.cn/project/2657/interface/api/433939 */
  USER_DISCOUNT = "mall.user.discount",

  /** 卡券用户积分使用开关 @ref https://yapi.hellobike.cn/project/2657/interface/api/436173 */
  USER_POINT_SWITCH = "mall.user.point.switch",

  /** 卡券商品优惠决策 @ref https://yapi.hellobike.cn/project/6782/interface/api/435391 */
  GOODS_PROMO = "mall.goods.promo",

  /** 取消订单 @ref https://yapi.hellobike.cn/project/6782/interface/api/433586 */
  ORDER_DECLINE = "coupon.order.decline",
}

export const interfaceConfig: InterfaceConfig = {
  default: {
    timeout: 30000,
    isShowLoading: false, // 是否需要显示loading遮罩
    loadingShow: "正在加载中...", // 显示loading遮罩的显示内容
    requestMethod: "POST",
    header: {
      "content-Type": "application/json;charset=UTF-8", // application/json
    },
    isResolveError: false, // 是否将服务端的错误当成resolve丢给外面 结构为 { errCode:'10001', errMsg:'错误信息...'}
    isShowNetErr: true, // 是否展示网络信号原因导致的接口错误，一般用在超时上
    showServerErr: true, // 是否展示服务端业务错误提示
    noLogin: false,
  },
  [ApiEnums.BUY_GOODS]: {
    isShowLoading: true,
  },
  [ApiEnums.GET_GROUPON_LIST]: {
    baseUrlFn() {
      const curEnvData = getCurEnvData();
      return curEnvData.grouponUrl;
    },
  },
  [ApiEnums.SKU_TIMELIMIT_LIST]: {
    baseUrlFn() {
      const curEnvData = getCurEnvData();
      return curEnvData.marketUrl;
    },
    isResolveError: true,
  },
  [ApiEnums.NEW_SKU_TIMELIMIT_LIST]: {
    baseUrlFn() {
      const curEnvData = getCurEnvData();
      return curEnvData.marketUrl;
    },
    isResolveError: true,
  },
  [ApiEnums.LIMIT_SWITCH]: {
    baseUrlFn() {
      const curEnvData = getCurEnvData();
      return curEnvData.marketUrl;
    },
    isResolveError: true,
  },
  [ApiEnums.TIMELIMIT_ORDER_QUERY]: {
    isShowLoading: false,
    baseUrlFn() {
      const curEnvData = getCurEnvData();
      return curEnvData.marketUrl;
    },
  },
  [ApiEnums.PURCHASE_GOODS]: {
    baseUrlFn() {
      const curEnvData = getCurEnvData();
      return curEnvData.marketUrl;
    },
  },
  [ApiEnums.GET_LAUNCH_LIST]: {
    baseUrlFn() {
      const curEnvData = getCurEnvData();
      return curEnvData.marketUrl;
    },
  },
  [ApiEnums.GET_JUMP_LINK]: {
    baseUrlFn() {
      const curEnvData = getCurEnvData();
      return curEnvData.marketUrl;
    },
  },
  [ApiEnums.OUT_USE_URL]: {
    baseUrlFn() {
      const curEnvData = getCurEnvData();
      return curEnvData.marketUrl;
    },
  },
  [ApiEnums.GET_RECOMMENDLIST]: {
    baseUrlFn() {
      const curEnvData = getCurEnvData();
      return curEnvData.marketUrl;
    },
  },
  [ApiEnums.GET_COUPONGOODS]: {
    baseUrlFn() {
      const curEnvData = getCurEnvData();
      return curEnvData.rentUrl;
    },
  },
  [ApiEnums.CHECK_REMINDER]: {
    baseUrlFn() {
      const curEnvData = getCurEnvData();
      return curEnvData.marketUrl;
    },
    isResolveError: true,
  },
  [ApiEnums.ADD_REMINDER]: {
    baseUrlFn() {
      const curEnvData = getCurEnvData();
      return curEnvData.marketUrl;
    },
    isResolveError: true,
  },
  [ApiEnums.CUSTOM_REFUND]: {
    baseUrlFn() {
      const curEnvData = getCurEnvData();
      return curEnvData.marketUrl;
    },
    isResolveError: true,
  },
  [ApiEnums.SUPPER_USER_DISCOUNT]: {
    baseUrlFn() {
      const curEnvData = getCurEnvData();
      return curEnvData.marketUrl;
    },
    isResolveError: true,
  },
  [ApiEnums.FETCH_RECM_SKU]: {
    baseUrlFn() {
      const curEnvData = getCurEnvData();
      return curEnvData.marketUrl;
    },
  },
  [ApiEnums.FETCH_COUPON_GOUSE_CONFIG]: {
    baseUrlFn() {
      const curEnvData = getCurEnvData();
      return curEnvData.marketUrl;
    },
  },
  [ApiEnums.FETCH_COMBI_PRODUCT]: {
    baseUrlFn() {
      const curEnvData = getCurEnvData();
      return curEnvData.marketUrl;
    },
  },
  [ApiEnums.FETCH_FREE_COMPOSE_PRODUCTS]: {
    baseUrlFn() {
      const curEnvData = getCurEnvData();
      return curEnvData.marketUrl;
    },
  },
  [ApiEnums.BUY_COMBI_GOODS]: {
    isShowLoading: true,
    baseUrlFn() {
      const curEnvData = getCurEnvData();
      return curEnvData.marketUrl;
    },
  },
  [ApiEnums.BUY_MULTI_GOODS]: {
    isShowLoading: true,
    baseUrlFn() {
      const curEnvData = getCurEnvData();
      return curEnvData.marketUrl;
    },
  },
  [ApiEnums.GET_BUY_LIST]: {
    baseUrlFn() {
      const curEnvData = getCurEnvData();
      return curEnvData.marketUrl;
    },
  },
  [ApiEnums.GET_BUY_DETAIL]: {
    baseUrlFn() {
      const curEnvData = getCurEnvData();
      return curEnvData.marketUrl;
    },
  },
  [ApiEnums.GET_WEIXINSIGN]: {
    noLogin: true,
    baseUrlFn() {
      // !!!!!!!!!!!!!!!!!!!!!!!!!!
      // !!!!!!!!!!巨坑!!!!!!!!!!!!
      // !!!!!务必使用生产环境接口!!!
      return envConfig.pro.serverUrl;
    },
  },
  [ApiEnums.FETCH_BIKE_CARD_LIST]: {
    baseUrlFn() {
      const curEnvData = getCurEnvData();
      return curEnvData.bikeGateway;
    },
  },
  [ApiEnums.BUY_BIKE_CARD]: {
    isShowLoading: true,
    baseUrlFn() {
      const curEnvData = getCurEnvData();
      return curEnvData.bikeGateway;
    },
  },
  [ApiEnums.PAY_AFTER_USE_STATUS]: {
    baseUrlFn() {
      const curEnvData = getCurEnvData();
      return curEnvData.serverUrl;
    },
  },
  [ApiEnums.PAY_AFTER_USE_FROZEN]: {
    baseUrlFn() {
      const curEnvData = getCurEnvData();
      return curEnvData.marketUrl;
    },
  },
  [ApiEnums.BIZ_SCENE_CHECK]: {
    baseUrlFn() {
      const curEnvData = getCurEnvData();
      return curEnvData.bikeGateway;
    },
  },
  [ApiEnums.APPID_PRE_CHECK]: {
    baseUrlFn() {
      const curEnvData = getCurEnvData();
      return curEnvData.marketUrl;
    },
  },
  [ApiEnums.SECKILL_KILL]: {
    baseUrlFn() {
      const curEnvData = getCurEnvData();
      return curEnvData.marketUrl;
    },
  },
  [ApiEnums.SECKILL_KILL_ORDER]: {
    baseUrlFn() {
      const curEnvData = getCurEnvData();
      return curEnvData.marketUrl;
    },
  },
  [ApiEnums.GET_USER_SIGN_RECORD]: {
    baseUrlFn() {
      const curEnvData = getCurEnvData();
      return curEnvData.marketUrl;
    },
  },
  [ApiEnums.FETCH_FREE_COMPOSE_PRODUCTS_LIST]: {
    baseUrlFn() {
      const curEnvData = getCurEnvData();
      return curEnvData.marketUrl;
    },
  },
  [ApiEnums.TWO_WHEEL_GET_ONE_BILLION_DISCOUNT_COUPON]: {
    baseUrlFn() {
      const curEnvData = getCurEnvData();
      return curEnvData.bikeGateway;
    },
  },
  [ApiEnums.USER_DISCOUNT]: {
    baseUrlFn() {
      const curEnvData = getCurEnvData();
      return curEnvData.marketUrl;
    },
  },
  [ApiEnums.USER_POINT_SWITCH]: {
    baseUrlFn() {
      const curEnvData = getCurEnvData();
      return curEnvData.marketUrl;
    },
  },
  [ApiEnums.GOODS_PROMO]: {
    baseUrlFn() {
      const curEnvData = getCurEnvData();
      return curEnvData.marketUrl;
    },
  },
  [ApiEnums.ORDER_DECLINE]: {
    baseUrlFn() {
      const curEnvData = getCurEnvData();
      return curEnvData.marketUrl;
    },
  },
};

// 优惠类型枚举
export enum promoTypEnum {
  /** 优惠券 */
  COUPON = 1,
  /** 奖励金 */
  REWARD = 2,
}

/**
 * 优惠类型枚举（couponPromoType 字段）
 * 2 是旧奖励金类型已废弃
 */
export enum CouponPromoTypeEnum {
  /** 营销优惠 */
  MARKETING = '1',
  /** 营销活动 */
  ACTIVITY = '3',
  /** 新奖励金 */
  REWARD_POINTS = '4',
}
